import { Loader2, CheckCircle, AlertTriangle } from "lucide-react";

export default function SaveStatusIndicator({ status }) {
  return (
    <div
      className={`flex items-center gap-1.5 px-2 py-1 text-[11px] font-medium pointer-events-none select-none ${
        status === "saving" ? "bg-blue-50 text-blue-700 border border-blue-200"
          : status === "saved" ? "bg-green-50 text-green-700 border border-green-200"
          : status === "error" ? "bg-red-50 text-red-700 border border-red-200"
          : ""
      }`}
      style={{
        opacity: status === "idle" ? 0 : 1,
        minWidth: 100,
        height: 28,
        visibility: status === "idle" ? "hidden" : "visible",
        borderRadius: 1,
      }}
      data-testid="save-status-indicator"
    >
      {status === "saving" && <><Loader2 className="w-3 h-3 animate-spin" /><span>Speichern...</span></>}
      {status === "saved" && <><CheckCircle className="w-3 h-3" /><span>Gespeichert</span></>}
      {status === "error" && <><AlertTriangle className="w-3 h-3" /><span>Fehler</span></>}
    </div>
  );
}
